/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * One recorded run, newest-first, for the history list.
 * @export
 * @interface BackfillRun
 */
export interface BackfillRun {
  /**
   *
   * @type {string}
   * @memberof BackfillRun
   */
  taskName: string;
  /**
   *
   * @type {string}
   * @memberof BackfillRun
   */
  status: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof BackfillRun
   */
  startedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof BackfillRun
   */
  finishedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof BackfillRun
   */
  errorMessage?: string | null;
}

/**
 * Check if a given object implements the BackfillRun interface.
 */
export function instanceOfBackfillRun(value: object): value is BackfillRun {
  if (!("taskName" in value) || value["taskName"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function BackfillRunFromJSON(json: any): BackfillRun {
  return BackfillRunFromJSONTyped(json, false);
}

export function BackfillRunFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BackfillRun {
  if (json == null) {
    return json;
  }
  return {
    taskName: json["taskName"],
    status: json["status"],
    startedAt: json["startedAt"] == null ? undefined : json["startedAt"],
    finishedAt: json["finishedAt"] == null ? undefined : json["finishedAt"],
    errorMessage:
      json["errorMessage"] == null ? undefined : json["errorMessage"],
  };
}

export function BackfillRunToJSON(json: any): BackfillRun {
  return BackfillRunToJSONTyped(json, false);
}

export function BackfillRunToJSONTyped(
  value?: BackfillRun | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    taskName: value["taskName"],
    status: value["status"],
    startedAt: value["startedAt"],
    finishedAt: value["finishedAt"],
    errorMessage: value["errorMessage"],
  };
}
